/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { UserSession, UserSession$inboundSchema } from "./usersession.js";

/**
 * Result type for listing user_sessions.
 */
export type ListUserSessionsResult = {
  items: Array<UserSession>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUserSessionsResult$inboundSchema: z.ZodMiniType<
  ListUserSessionsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(UserSession$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listUserSessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionsResult' from JSON`,
  );
}
